module.exports = __webpack_public_path__ + "img/imiwin-support.41d2bbc5.png";